<template>
  <div class="animated fadeIn">
    <!-- <StyledDialog>
      <div slot="header">
        <h2>{{seminar.restaurant_edit.CommonName}}</h2>
      </div>
      <div slot="details">
        <div>{{seminar.restaurant_edit.Address1}} {{seminar.restaurant_edit.Address2}}</div>
        <div>{{seminar.restaurant_edit.City }}</div>
      </div>
      <span slot="entityType">location</span>
    </StyledDialog>-->
    <b-row>
      <b-col lg="12">
        <!-- <b-card>
        <div slot="header">User Profile</div>-->
        <b-form @submit.prevent="save">
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth">Restaurant Name*</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model.lazy="seminar.restaurant_edit.Name"
                    placeholder="Restaurant Name"
                    required
                    type="text"
                    autocomplete="off"
                    id="Name"
                    @change.native="addDirtyField"
                  ></b-form-input>
                  <!-- <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-registered appendIcon"></i>
                    </b-input-group-text>
                  </b-input-group-append>-->
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth">Website</b-input-group-text>
                  </b-input-group-prepend>

                  <b-form-input
                    v-model.lazy="seminar.restaurant_edit.WebUrl"
                    placeholder="Website"
                    type="text"
                    autocomplete="off"
                    id="WebUrl"
                    v-on:change.native="addDirtyField"
                  ></b-form-input>
                  <!-- 
                  <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-globe"></i>
                    </b-input-group-text>
                  </b-input-group-append>-->
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth">Address</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model.lazy="seminar.restaurant_edit.Address1"
                    placeholder="Primary Address"
                    type="text"
                    autocomplete="off"
                    id="Address1"
                    v-on:change.native="addDirtyField"
                  ></b-form-input>
                  <!-- <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-registered appendIcon"></i>
                    </b-input-group-text>
                  </b-input-group-append>-->
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth">Ste./ Bldg</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model.lazy="seminar.restaurant_edit.Address2"
                    placeholder="Secondary Address"
                    type="text"
                    autocomplete="off"
                    id="Address2"
                    v-on:change.native="addDirtyField"
                  ></b-form-input>
                  <!-- <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-star appendIcon"></i>
                    </b-input-group-text>
                  </b-input-group-append>-->
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth">City</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model.lazy="seminar.restaurant_edit.City"
                    placeholder="City"
                    type="text"
                    autocomplete="off"
                    id="City"
                    v-on:change.native="addDirtyField"
                  ></b-form-input>
                  <!-- <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-star appendIcon"></i>
                    </b-input-group-text>
                  </b-input-group-append>-->
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth">State</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model.lazy="seminar.restaurant_edit.State"
                    placeholder="State"
                    type="text"
                    autocomplete="off"
                    id="State"
                    v-on:change.native="addDirtyField"
                  ></b-form-input>
                  <!-- <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-registered appendIcon"></i>
                    </b-input-group-text>
                  </b-input-group-append>-->
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth">Zipcode*</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model.lazy="seminar.restaurant_edit.Zip"
                    required
                    placeholder="Zipcode"
                    type="text"
                    autocomplete="off"
                    id="Zip"
                    v-on:change.native="addDirtyField"
                  ></b-form-input>
                  <!-- <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-star appendIcon"></i>
                    </b-input-group-text>
                  </b-input-group-append>-->
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth">Email</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model.lazy="seminar.restaurant_edit.Email"
                    placeholder="Email Address"
                    type="email"
                    autocomplete="off"
                    id="Email"
                    v-on:change.native="addDirtyField"
                  ></b-form-input>
                  <!-- <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-envelope appendIcon"></i>
                    </b-input-group-text>
                  </b-input-group-append>-->
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth">Phone</b-input-group-text>
                  </b-input-group-prepend>

                  <b-form-input
                    v-model.lazy="seminar.restaurant_edit.Phone"
                    placeholder="Phone Number"
                    type="text"
                    v-mask="'(###) ###-####'"
                    autocomplete="off"
                    id="Phone"
                    v-on:change.native="addDirtyField"
                  ></b-form-input>

                  <!-- <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-phone appendIcon"></i>
                    </b-input-group-text>
                  </b-input-group-append>-->
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row v-if="false">
            <b-col md="12">
              <b-card>
                <div slot="header">
                  <a v-b-toggle.collapse2 style="cursor:pointer;">
                    <i class="fa fa-caret-down fa-lg mr-2" v-if="seen" @click="toggleVisibility" />
                    <i class="fa fa-caret-up fa-lg mr-2" v-if="!seen" @click="toggleVisibility" />
                    <span v-if="seen" @click="toggleVisibility">More</span>
                    <span v-if="!seen" @click="toggleVisibility">Less</span>
                  </a>
                </div>
                <b-collapse id="collapse2" class="mt-2">
                  <b-tabs>
                    <b-tab active>
                      <template slot="title">
                        <i class="fa fa-wrench"></i>
                        <span class="ml-1">Service</span>
                      </template>
                      <!-- <b-list-group-item class="pt-0" style="border: none; ">
                        <b-row>
                          <b-button
                            class="mr-0 ml-auto float-right"
                            size="sm"
                            variant="success"
                            @click="addLocation"
                          >
                            <i class="fa fa-plus"></i>
                            Add
                          </b-button>
                        </b-row>
                      </b-list-group-item>-->
                      <b-list-group>
                        <!-- <LocationRow
                          v-for="location in seminar.restaurant_edit.Locations"
                          :key="location.LocationID"
                          :location="location"
                        />-->
                      </b-list-group>
                    </b-tab>
                    <b-tab>
                      <template slot="title">
                        <i class="fa fa-dollar"></i>
                        <span class="ml-1">Sales</span>
                      </template>
                      <!-- <b-list-group-item class="pt-0" style="border: none; ">
                        <b-row>
                          <b-button
                            class="mr-0 ml-auto float-right"
                            size="sm"
                            variant="success"
                            @click="addContact"
                          >
                            <i class="fa fa-plus"></i>
                            Add
                          </b-button>
                        </b-row>
                      </b-list-group-item>-->
                      <b-list-group>
                        <!-- <ContactRow
                          v-for="contact in seminar.restaurant_edit.Contacts"
                          :key="contact.ContactID"
                          :contact="contact"
                        />-->
                      </b-list-group>
                    </b-tab>
                    <b-tab>
                      <template slot="title">
                        <i class="fa fa-cogs"></i>
                        <span class="ml-1">Parts</span>
                      </template>
                    </b-tab>
                    <b-tab>
                      <template slot="title">
                        <i class="fa fa-image"></i>
                        <span class="ml-1">Graphics</span>
                      </template>
                    </b-tab>
                  </b-tabs>
                </b-collapse>
              </b-card>
            </b-col>
          </b-row>

          <div class="form-group form-actions" style="float:right;">
            <b-button class="mr-2 mt-2" size="md" variant="outline-primary" @click="back">
              <!-- <i class="fa fa-close"></i> -->
              Close
            </b-button>
            <b-button
              class="mr-0 mt-2"
              type="submit"
              size="md"
              variant="primary"
              :disabled="isClean"
            >
              <i class="fa fa-save"></i>
              Save
            </b-button>
          </div>
          <div class="form-group form-actions" style="float:right;">
            <b-alert
              class="btn mr-4 mt-2"
              :show="dismissCountDown"
              fade
              variant="light"
              :dismissed="dismissCountdown=0"
              @dismiss-count-down="countDownChanged"
            >
              Your information has been saved
              <!-- <b-progress variant="info" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress> -->
            </b-alert>
            <b-alert
              class="btn mr-4 mt-2"
              :show="dismiss2CountDown"
              fade
              variant="danger"
              :dismissed="dismiss2Countdown=0"
              @dismiss-count-down="countDown2Changed"
            >
              Your information could not be saved. Check all fields carefully.
              <!-- <b-progress variant="info" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress> -->
            </b-alert>
          </div>
        </b-form>
        <!-- </b-card> -->
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import StyledDialog from "@/components/dialogs/StyledModal.vue";
import { required, email, helpers } from "vuelidate/lib/validators";
const alpha = helpers.regex("alpha", /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/);

export default {
  name: "RestaurantProfile",
  data() {
    return {
      selected: [], // Must be an array reference!
      dirtyFields: [],
      show: true,
      seen: true,
      isSaving: false,
      isSaved: false,
      dismissSecs: 3,
      dismissCountDown: 0,
      dismiss2Secs: 3,
      dismiss2CountDown: 0,
      showDismissibleAlert: false
    };
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    toggleVisibility() {
      this.seen = !this.seen;
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    countDown2Changed(dismiss2CountDown) {
      this.dismiss2CountDown = dismiss2CountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    save() {
      // this.$v.$touch();
      // if (this.$v.$error) {
      //   this.dismiss2CountDown = this.dismiss2Secs;
      // } else {
      //   this.$store
      //     .dispatch("dealership/Save", {
      //       client: this.$store.state.seminar.restaurant_edit,
      //       fields: this.dirtyFields
      //     })
      //     .then(
      //       (this.dirtyFields = [])((this.dismissCountDown = this.dismissSecs))
      //     );
      // }
      this.$v.$touch();
      if (this.$v.$error) {
        this.dismiss2CountDown = this.dismiss2Secs;
      } else {
        this.$store
          .dispatch("saveOp/BuildSaveOperation")
          .then(
            this.$store
              .dispatch("saveOp/EmitSave")
              .then(
                (this.dirtyFields = [])(
                  (this.dismissCountDown = this.dismissSecs)
                )(this.$store.state.saveOp.DestroySaveOperation)
              )
          );
      }
    },

    addDirtyField: function(event) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== event.target.id
      );
      this.dirtyFields.push({
        FieldName: event.target.id,
        FieldValue: event.target.value
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    }
  },
  computed: {
    ...mapState(["seminar"]),
    ...mapActions("saveOp", ["Save", "EmitSave"]),
    isClean() {
      return this.dirtyFields.length === 0;
    }
  },
  components: {
    StyledDialog
  },
  created() {
  },

  mounted() {
    this.$store.state.saveOp.localUrl = "/Seminar/SaveRestaurant/";
    this.$store.state.saveOp.localVariableName = "_r";
    this.$store.state.saveOp.localVariableObject = this.$store.state.seminar.restaurant_edit;
    this.$store.state.saveOp.localFieldToSet = "RestaurantID";
    this.$store.state.saveOp.localReturnObject = "SaveRestaurantResult";
  },
  validations: {
    seminar: {
      restaurant_edit: {
        Name: {
          required
        }
      }
    }
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.input-group-text {
  color: #111;
}
</style>
